module.exports = __webpack_public_path__ + "front/img/p7.0527a610.png";